import { DatePickerMonth
// Icon
} from '@livable/saas-react-components';
import {
//  Button,
Grid } from '@mui/material';
import React from 'react';
// import { useTranslation } from 'react-i18next';
// import ExportStatementsModal from 'src/components/shared/ExportStatementsModal';
// import PrintStatementsModal from 'src/components/shared/PrintStatementsModal';
// import SendStatementsModal from 'src/components/statements/SendStatementsModal';
import useStyles from './styles';
export default function ActionBar(_ref) {
  let pickerDate = _ref.pickerDate,
    setPickerDate = _ref.setPickerDate;
  const classes = useStyles();
  // const { t } = useTranslation();

  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10,
    className: classes.topActionBar
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sm: 12,
    md: 4,
    lg: true,
    className: classes.topActionDatepicker
  }, /*#__PURE__*/React.createElement(DatePickerMonth, {
    date: pickerDate,
    setDate: setPickerDate
  })));
}